import * as React from 'react'
import {
  BulkActionsProps,
  BulkReassignButton,
  BulkUpdateStatusButton,
  BulkReopenButton,
  BulkAddActivityButton,
} from '@user/components/xGrid'
import { OpportunityBulkActionFooter } from './OpportunityBulkActionFooter'
import { OpportunityBulkDelete } from './OpportunityBulkDelete'
import { useCheckBulkPermissions } from '@user/store/authorization/hooks'
import { OpportunityBulkUpdateNextActionDate } from './OpportunityBulkUpdateNextActionDate'
import { BulkUpdateExpectedClosingDateButton } from '@user/components/xGrid/atoms/BulkActions/BulkUpdateExpectedClosingDate'
import { BulkCloseWinButton } from '@user/components/xGrid/atoms/BulkActions/BulkActionCloseWin'
import Stack from '@mui/material/Stack'
import OpportunityBulkAddNote from './OpportunityBulkAddNote'

export const OpportunityBulkActions: React.FC<BulkActionsProps> = (props) => {
  const { hasUpdatePermission, hasDeletePermission } =
    useCheckBulkPermissions('opportunities')

  return (
    <>
      <Stack gap="10px!important" direction="row" flexWrap="wrap">
        <BulkUpdateStatusButton hasPermission={hasUpdatePermission} />
        <BulkReopenButton hasPermission={hasUpdatePermission} />
        <BulkReassignButton hasPermission={hasUpdatePermission} />
        <OpportunityBulkDelete {...props} hasPermission={hasDeletePermission} />
        <OpportunityBulkUpdateNextActionDate
          {...props}
          hasPermission={hasUpdatePermission}
        />
        <BulkUpdateExpectedClosingDateButton
          hasPermission={hasUpdatePermission}
        />
        <BulkCloseWinButton hasPermission={hasUpdatePermission} />
        <BulkAddActivityButton hasPermission={true} />
        <OpportunityBulkAddNote
          {...props}
          hasPermission={hasUpdatePermission}
        />
      </Stack>
      <OpportunityBulkActionFooter {...props} />
    </>
  )
}
OpportunityBulkActions.displayName = 'OpportunityBulkActions'
